/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Dashboard_Card_DescInputs */

const en_company_dashboard_card_desc = /** @type {(inputs: Company_Dashboard_Card_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage job postings and applications.`)
};

const de_company_dashboard_card_desc = /** @type {(inputs: Company_Dashboard_Card_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellenanzeigen und Bewerbungen verwalten.`)
};

/**
* | output |
* | --- |
* | "Manage job postings and applications." |
*
* @param {Company_Dashboard_Card_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_dashboard_card_desc = /** @type {((inputs?: Company_Dashboard_Card_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Dashboard_Card_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_dashboard_card_desc(inputs)
	return en_company_dashboard_card_desc(inputs)
});